// Courses Variants Configuration

import { setCourse1 } from "@/store/slices/university";
import type { UniversityState } from "@/store/slices/university";
import { Form_5 } from "@/components/organisms/admin/forms";
import { COURSES_VARIANTS } from "../../sectionTypes";
import { COURSES_1_CONSTANTS } from "../../fields/courses/courses_1";
import {
  createCourse,
  updateCourse,
  deleteCourse,
  getCoursesByUniversitySettingsId,
} from "@/api/admin/course";
import type { VariantConfig } from "../types";
import { COMMON_CONSTANTS } from "../types";

export const COURSES_VARIANTS_CONFIG: Record<string, VariantConfig> = {
  [COURSES_VARIANTS.COURSES_1]: {
    id: COURSES_VARIANTS.COURSES_1,
    name: "Courses 1",
    description: "Courses 1",
    componentFields: COURSES_1_CONSTANTS.COURSES_FIELDS_CONFIG,
    showTable: false,
    setAction: setCourse1,
    formComponent: Form_5,
    previewComponent: null,
    selector: (state: UniversityState) => state.course_1,
    createMethod: createCourse,
    updateMethod: updateCourse,
    fetchMethod: getCoursesByUniversitySettingsId,
    deleteMethod: deleteCourse,
    hasParentChildStructure: false,
    TREE_CONFIG: COURSES_1_CONSTANTS.TREE_CONFIG,
    transformDataForPreview: (data: any) => ({ data: data || {} }),
    constants: { ...COMMON_CONSTANTS, SUCCESS_MESSAGE: "Course saved successfully" },
  },
};

export const getCourseVariantDetails = (variantId: string) => 
  COURSES_VARIANTS_CONFIG[variantId];

